export default __webpack_public_path__ + "static/media/zsah_accreditations.3a94e034.png";